var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileInfo.jinja');
require('./MemberProfileInfo.less');

var Inner = require('front/components/MemberProfile/MemberProfileInfoInner');
var Runtime = require('front/components/MemberProfile/MemberProfileInfoRuntime.jinja');

var MemberProfileButtonsEdit = require('front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MemberProfileButtonsEdit': {selector: '.MemberProfileButtonsEdit', viewConstructor: MemberProfileButtonsEdit}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updateInfo', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfileInfoInner')[0]
        });

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updateInfo', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$('.MemberProfileInfo-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfileInfoInner')[0]
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileInfo.js
// module id = 196
// module chunks = 0